import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { NormalInputBase } from '../NormalInputBase';
export const TextInput = forwardRef((props, ref) => {
    return _jsx(NormalInputBase, { ref: ref, ...props });
});
